import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=9842e992&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9842e992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目管理\\旧换新\\源码\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9842e992')) {
      api.createRecord('9842e992', component.options)
    } else {
      api.reload('9842e992', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=9842e992&scoped=true&", function () {
      api.rerender('9842e992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activity/edit.vue"
export default component.exports